const prodConfig = {
  apiKey: 'AIzaSyBqMb-v5qJX9w6Y0Hk-xh8443o_Y8q5QUs',
  authDomain: 'initiative-react.firebaseapp.com',
  projectId: 'initiative-react',
  storageBucket: 'initiative-react.appspot.com',
  appId: '1:946733183458:web:7f1d31266f489c16ea49bb'
};

const devConfig = {
  apiKey: 'AIzaSyBtM2jErTIYkBLjyac7On0x-JSrokRRp14',
  authDomain: 'initiative-dev.firebaseapp.com',
  projectId: 'initiative-dev',
  storageBucket: 'initiative-dev.appspot.com',
  appId: '1:264929203463:web:fdf5d901342ecf2c6b61a2'
};

const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

export default config;